import PlaylistVideoComponents from '@components/Video/Playlist'
import { ViewportTypeValues } from '@contexts/viewport'
import useViewportType from '@hooks/useViewportType'
import { FunctionComponent, useEffect, useState } from 'react'
import usePlaylist from '../hooks/usePlaylist'

const { Title, TitleWrapper, PlaylistWrapper, Container } =
  PlaylistVideoComponents

const Playlist: FunctionComponent<{ hideInDesktop: boolean }> = (props) => {
  const { hideInDesktop } = props
  const viewportType = useViewportType()
  const [hidePlaylist, setHidePlaylist] = useState<boolean>(false)
  const data = usePlaylist()

  useEffect(() => {
    if (hideInDesktop) {
      setHidePlaylist(viewportType === ViewportTypeValues.DESKTOP)
    } else {
      setHidePlaylist(viewportType !== ViewportTypeValues.DESKTOP)
    }
  }, [viewportType, hideInDesktop])

  if (!data || hidePlaylist) {
    return null
  }

  const { title, items } = data

  return (
    <Container hideInDesktop={hideInDesktop}>
      <TitleWrapper>
        <Title>{title}</Title>
      </TitleWrapper>
      <PlaylistWrapper>{items}</PlaylistWrapper>
    </Container>
  )
}

export default Playlist
